import { observer } from "mobx-react";
import { NumberQuestion, YesNoQuestion } from "../common/commonComponents";
import { FC } from "react";
import { IncreaseOfShareCapitalForm } from "./increaseOfShareCapitalDomain";

import { useTranslation } from "../../stores/RootStoreContext";

export const GuaranteeConsortium: FC<{ form: IncreaseOfShareCapitalForm }> = observer(
  ({ form }) => {
    const { t } = useTranslation();
    return (
      <>
        <YesNoQuestion
          question={t("decisions.increaseShareCapitalAgainstCash.newShares.guaranteeConsortium")}
          field={form.shareIssue.isGuaranteeConsortiumEstablished}
          isLocked={form.isProjectLocked}
        />
        {form.shareIssue.isGuaranteeConsortiumEstablished.value && (
          <>
            <NumberQuestion
              field={form.shareIssue.guaranteeConsortiumCommission.numberOfShares}
              question={t(
                "decisions.increaseShareCapitalAgainstCash.newShares.guaranteedShares.title",
              )}
              label={t("decisions.number-of-shares")}
              isLocked={form.isProjectLocked}
            />
            <NumberQuestion
              field={form.shareIssue.guaranteeConsortiumCommission.percentOfGuaranteedAmount}
              question={t(
                "decisions.increaseShareCapitalAgainstCash.newShares.guaranteedCommission.title",
              )}
              label={t(
                "decisions.increaseShareCapitalAgainstCash.newShares.guaranteedCommission.label",
              )}
              isLocked={form.isProjectLocked}
            />
          </>
        )}
      </>
    );
  },
);
